// MUI-compatible elevation system
// Maps to Material Design elevation levels
export const elevation = {
  none: 0,
  minimal: 1,    // For subtle raised elements like buttons
  low: 2,        // For cards, app bars
  medium: 4,     // For floating action buttons, dropdowns
  high: 8,       // For navigation drawer, modal dialogs
  highest: 16,   // For snackbars, tooltips
  
  // Semantic elevation for common components
  card: 2,
  paper: 5,
  dialog: 8,
  drawer: 16,
  appBar: 4,
  fab: 6,
  menu: 8,
  tooltip: 16,
} as const;